import textUrl from '../assets/terms.txt'
import ReactMarkdown from 'react-markdown'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { use } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { AuthContext } from '../hooks/auth-redirector'
import { termsAgree } from '../firebase/firestore'

const TermsDialog: React.FC = () => {
  const user = use(AuthContext)
  const open = user.terms_agree_version !== 1
  const {data: text} = useQuery({
    queryKey: ['terms'],
    enabled: open,
    queryFn: ()=> fetch(textUrl).then(r=> r.text())
  })
  const queryClient = useQueryClient()
  const mutate = useMutation({
    mutationFn: ()=> termsAgree(user.uid),
    onSuccess: ()=> {
      queryClient.setQueryData(['me'], (me: typeof user)=> ({
        ...me,
        terms_agree_version: 1
      }))
    }
  })

  return <Dialog open={open}>
    <DialogTitle>
      利用規約
    </DialogTitle>
    <DialogContent>
      <ReactMarkdown>{text}</ReactMarkdown>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={()=> { mutate.mutate() }}
        color='primary'
        variant='contained'
      >
        同意する
      </Button>
    </DialogActions>
  </Dialog>
}
export default TermsDialog